import React from 'react';
import { CheckCircle2 } from 'lucide-react';



export default function WhatToExpectSection({ title, description, expectItems }) {
    return (
        <section className="w-full bg-[#FFFFFF] pb-[70px] lg:pb-[100px] text-left">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px] flex flex-col gap-10 lg:gap-14">

                <div className="flex flex-col gap-3">
                    <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600]">
                        {title}
                    </h2>
                    <p className="font-graphik font-[400] text-[15px] sm:text-[17px] leading-relaxed text-[#555555]">
                       {description}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {expectItems.map((item, index) => (
                        <div
                            key={index}
                            className="flex items-start gap-3.5 p-6 sm:p-7 bg-[#F8F9FA] border border-[#01386A]/10 hover:border-[#EA6B24]/40 hover:shadow-md transition-all duration-300 group cursor-default"
                        >
                            <div className="shrink-0 mt-0.5">
                                <CheckCircle2 className="w-5 h-5 text-[#EA6B24] group-hover:scale-110 transition-transform duration-300" strokeWidth={2.2} />
                            </div>
                            <p className="font-sora text-[14px] sm:text-[15px] font-[600] text-[#01386A] leading-snug">
                                {item}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}